import styled from '@emotion/styled';
import { toRgba } from 'utils/toRgba';
import { Variables } from 'styles/variables/variables';

interface ButtonProps {
    color: string;
}

export const Container = styled.div`
    position: relative;
    display: inline-block;
    max-width: 100%;
    font-family: ${Variables.assistant};
`;

export const Button = styled.button<ButtonProps>`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 0.2rem 0.6rem;
    font-family: ${Variables.assistant};
    font-size: 16px;
    line-height: 20px;
    background-color: ${({ color }) => toRgba(color, 0.1)}; /* 10% opacity */

    border-radius: 9999px; /* pill shape */

    font-weight: 500;
    color: ${({ color }) => color};
    cursor: pointer;
    max-width: 100%;
    min-width: 0;
    border: none;
    transition:
        background-color 0.2s ease,
        box-shadow 0.2s ease;

    svg {
        width: 1rem;
        height: 1rem;
        color: ${({ color }) => color};
        transition: transform 0.2s ease;
        flex-shrink: 0;
    }

    &:hover:not(:disabled) {
        border: 1px solid ${({ color }) => color};
        background-color: ${({ color }) => toRgba(color, 0.15)}; /* 15% opacity */
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
    }

    &:disabled {
        opacity: 0.55;
        cursor: not-allowed;
        box-shadow: none;
    }
`;

export const Label = styled.span`
    flex: 1 1 auto;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-family: ${Variables.assistant};
    font-size: 16px;
    line-height: 20px;
`;

export const Dot = styled.span`
    width: 10px;
    height: 10px;
    border-radius: 50%;
    flex-shrink: 0;
    background-color: currentColor;
`;

export const DropdownItem = styled.div`
    display: flex;
    align-items: center;
    padding: 4px 6px;
    font-family: ${Variables.assistant};
    font-size: 16px;
    line-height: 20px;
    font-weight: 400;
    cursor: pointer;
    color: #282828;
    background: #fff;

    &:hover {
        background-color: #f0fdf4;
    }

    span {
        margin-left: 8px;
    }
`;

export const PortalDropdown = styled.div`
    position: absolute;
    background: white;
    border: 1px solid #d1fae5;
    font-family: ${Variables.assistant};
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    z-index: 10000;
    overflow: hidden;
    min-width: 200px;
`;
